import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { tipo, validando } = useContext(AuthContext);
  if (validando) return null;
  return tipo ? children : <Navigate to="/" replace />;
}
